<script>
  import { getContext, onMount, setContext } from 'svelte'
  import { writable } from 'svelte/store'
  export let width
  export let height

  const animate = getContext('animate')

  let canvas
  const store = writable({ canvas, width, height })
  setContext('store', store)

  $: store.update(() => ({ canvas, width, height }))

  onMount(() => {
    const ctx = canvas.getContext('2d')

    let raf
    function render() {
      ctx.clearRect(0, 0, width, height)
    }

    function loop() {
      raf = requestAnimationFrame(loop)
      render()
    }

    if (animate) {
      raf = requestAnimationFrame(loop)
    } else {
      raf = requestAnimationFrame(render)
    }

    return () => cancelAnimationFrame(raf)
  })
</script>

<canvas {width} {height} bind:this={canvas}>
  {#if canvas && width && height}
    <slot />
  {/if}
</canvas>
